import { set } from 'Global/Helpers/objectHelpers'

import { SIGN_OUT } from 'Global/Stores/auth'

import { FEEDBACK_SEND_FULFILLED } from 'Global/Stores/feedback'
import { GROUP_CREATE_FULFILLED } from 'Global/Stores/groups'
import { PASSWORD_CHANGE_FULFILLED } from 'Global/Stores/auth'
import { USER_CREATE_FULFILLED } from 'Modules/UsersModule/actionTypes'

import { RESERVATION_CREATE_FULFILLED, RESERVATION_DELETE_FULFILLED, RESERVATION_EDIT_FULFILLED } from './reservations'

const CHANGELOG_MODAL_HIDE = 'MODALS/CHANGELOG/HIDE'
const CHANGELOG_MODAL_SHOW = 'MODALS/CHANGELOG/SHOW'

const CONFIRMATION_MODAL_HIDE = 'MODALS/CONFIRMATION/HIDE'
const CONFIRMATION_MODAL_SHOW = 'MODALS/CONFIRMATION/SHOW'

const FEEDBACK_MODAL_HIDE = 'MODALS/FEEDBACK/HIDE'
const FEEDBACK_MODAL_SHOW = 'MODALS/FEEDBACK/SHOW'

const GROUP_CREATE_MODAL_HIDE = 'MODALS/GROUP_CREATE/HIDE'
const GROUP_CREATE_MODAL_SHOW = 'MODALS/GROUP_CREATE/SHOW'

const MY_ACCOUNT_MODAL_HIDE = 'MODALS/MY_ACCOUNT/HIDE'
const MY_ACCOUNT_MODAL_SHOW = 'MODALS/MY_ACCOUNT/SHOW'

const RESERVATION_CREATE_MODAL_HIDE = 'MODALS/RESERVATION_CREATE/HIDE'
const RESERVATION_CREATE_MODAL_SHOW = 'MODALS/RESERVATION_CREATE/SHOW'

const RESERVATION_EDIT_MODAL_HIDE = 'MODALS/RESERVATION_EDIT/HIDE'
const RESERVATION_EDIT_MODAL_SHOW = 'MODALS/RESERVATION_EDIT/SHOW'

const SETTINGS_MODAL_HIDE = 'MODALS/SETTINGS/HIDE'
const SETTINGS_MODAL_SHOW = 'MODALS/SETTINGS/SHOW'

const USER_CREATE_MODAL_HIDE = 'MODALS/USER_CREATE/HIDE'
const USER_CREATE_MODAL_SHOW = 'MODALS/USER_CREATE/SHOW'

export const changelogModalHide = () => ({
  type: CHANGELOG_MODAL_HIDE,
})

export const changelogModalShow = () => ({
  type: CHANGELOG_MODAL_SHOW,
})

export const confirmationModalHide = () => ({
  type: CONFIRMATION_MODAL_HIDE,
})

export const confirmationModalShow = (message, onAccept) => ({
  payload: { message, onAccept },
  type: CONFIRMATION_MODAL_SHOW,
})

export const feedbackModalHide = () => ({
  type: FEEDBACK_MODAL_HIDE,
})

export const feedbackModalShow = () => ({
  type: FEEDBACK_MODAL_SHOW,
})

export const groupCreateModalHide = () => ({
  type: GROUP_CREATE_MODAL_HIDE,
})

export const groupCreateModalShow = () => ({
  type: GROUP_CREATE_MODAL_SHOW,
})

export const myAccountModalHide = () => ({
  type: MY_ACCOUNT_MODAL_HIDE,
})

export const myAccountModalShow = () => ({
  type: MY_ACCOUNT_MODAL_SHOW,
})

export const reservationCreateModalHide = () => ({
  type: RESERVATION_CREATE_MODAL_HIDE,
})

export const reservationCreateModalShow = () => ({
  type: RESERVATION_CREATE_MODAL_SHOW,
})

export const reservationEditModalHide = () => ({
  type: RESERVATION_EDIT_MODAL_HIDE,
})

export const reservationEditModalShow = reservation => ({
  payload: reservation,
  type: RESERVATION_EDIT_MODAL_SHOW,
})

export const settingsModalHide = () => ({
  type: SETTINGS_MODAL_HIDE,
})

export const settingsModalShow = () => ({
  type: SETTINGS_MODAL_SHOW,
})

export const userCreateModalHide = () => ({
  type: USER_CREATE_MODAL_HIDE,
})

export const userCreateModalShow = () => ({
  type: USER_CREATE_MODAL_SHOW,
})

const initialState = {
  changelog: { visible: false },
  confirmation: { message: '', onAccept: {}, visible: false },
  feedback: { visible: false },
  groupCreate: { visible: false },
  myAccount: { visible: false },
  reservationCreate: { visible: false },
  reservationEdit: { reservation: {}, visible: false }, // TODO
  settings: { visible: false },
  userCreate: { visible: false },
}

const reducer = (state = initialState, action) => {
  const { payload, type } = action

  switch (type) {
    case CHANGELOG_MODAL_HIDE:
      return set(`changelog`, { visible: false }, state)

    case CHANGELOG_MODAL_SHOW:
      return set(`changelog`, { visible: true }, state)

    case CONFIRMATION_MODAL_HIDE:
      return set(
        `confirmation`,
        {
          message: '',
          onAccept: {},
          visible: false,
        },
        state,
      )

    case CONFIRMATION_MODAL_SHOW:
      return set(`confirmation`, { message: payload.message, onAccept: payload.onAccept, visible: true }, state)

    case FEEDBACK_MODAL_HIDE:
      return set(`feedback`, { visible: false }, state)

    case FEEDBACK_MODAL_SHOW:
      return set(`feedback`, { visible: true }, state)

    case FEEDBACK_SEND_FULFILLED:
      return set(`feedback`, { visible: false }, state)

    case GROUP_CREATE_FULFILLED:
    case GROUP_CREATE_MODAL_HIDE:
      return set(`groupCreate`, { visible: false }, state)

    case GROUP_CREATE_MODAL_SHOW:
      return set(`groupCreate`, { visible: true }, state)

    case MY_ACCOUNT_MODAL_HIDE:
      return set(`myAccount`, { visible: false }, state)

    case MY_ACCOUNT_MODAL_SHOW:
      return set(`myAccount`, { visible: true }, state)

    case PASSWORD_CHANGE_FULFILLED:
      return set(`myAccount`, { visible: false }, state)

    case RESERVATION_CREATE_FULFILLED:
      return set(`reservationCreate`, { reservation: {}, visible: false }, state)

    case RESERVATION_CREATE_MODAL_HIDE:
      return set(`reservationCreate`, { reservation: {}, visible: false }, state)

    case RESERVATION_CREATE_MODAL_SHOW:
      return set(`reservationCreate`, { visible: true }, state)

    case RESERVATION_DELETE_FULFILLED:
      return set(`reservationEdit`, { reservation: {}, visible: false }, state)

    case RESERVATION_EDIT_FULFILLED:
      return set(`reservationEdit`, { reservation: {}, visible: false }, state)

    case RESERVATION_EDIT_MODAL_HIDE:
      return set(`reservationEdit`, { reservation: {}, visible: false }, state)

    case RESERVATION_EDIT_MODAL_SHOW:
      return set(`reservationEdit`, { reservation: payload, visible: true }, state)

    case SETTINGS_MODAL_HIDE:
      return set(`settings`, { visible: false }, state)

    case SETTINGS_MODAL_SHOW:
      return set(`settings`, { visible: true }, state)

    case USER_CREATE_FULFILLED:
    case USER_CREATE_MODAL_HIDE:
      return set(`userCreate`, { visible: false }, state)

    case USER_CREATE_MODAL_SHOW:
      return set(`userCreate`, { visible: true }, state)

    case '@@router/LOCATION_CHANGE':
      return initialState

    case SIGN_OUT:
      return initialState

    default:
      return state
  }
}

export default reducer
